import {
    Button,
    componentStyles,
    VerticalStackStretch,
} from "@mallardbay/lib-react-components"
import React from "react"

import { useSchema } from "~components/pages/listing/checkout/continue-as-guest-form/continue-as-guest-form-helpers"
import { BUTTON_TYPES, FORM_MODES } from "~config/constants"
import GuestUserFormInputs from "~components/shared/guest-user-form-inputs"
import Form from "~components/shared/hook-form/core/form"
import COPY from "~config/copy-constants"
import useLogInAsGuestUser from "~utils/useLogInAsGuestUser"

interface Props {
    readonly onSuccess?: () => void
    readonly isSingleColumn?: boolean
}

export default function ContinueAsGuestForm({
    onSuccess,
    isSingleColumn = true,
}: Props) {
    const styles = useStyles()
    const schema = useSchema()

    const { logInAsGuestUser, isLoading } = useLogInAsGuestUser({
        onSuccess,
    })

    return (
        <Form mode={FORM_MODES.ALL} schema={schema} onSubmit={logInAsGuestUser}>
            <VerticalStackStretch style={styles.stack}>
                <GuestUserFormInputs isSingleColumn={isSingleColumn} />
                <Button
                    style={styles.button}
                    isLoading={isLoading}
                    type={BUTTON_TYPES.SUBMIT}
                >
                    {COPY.CONTINUE_AS_GUEST}
                </Button>
            </VerticalStackStretch>
        </Form>
    )
}

function useStyles() {
    return componentStyles({
        button: {
            alignSelf: "flex-end",
        },
        stack: {
            gap: 8,
        },
    })
}
